import { EducationPage, IEducationState } from './education.typing';

export const AMOUNT_RANDOM_QUESTIONS = 5;

export const INIT_EDUCATION_STATE: IEducationState = {
  page: EducationPage.Level,
  rating: 0,
  isLoading: false,
};
